export function generateRandomNumber(from: number = 2600, to: number = 4600): number {
  return Math.max(Math.floor(Math.random() * to), from);
}
